<template>
  <div>
    <v-btn
      class="mbv-trigger"
      color="primary"
      round
      depressed
      dark
      :disabled="pending"
      @click="dialog = true"
    >
      <v-icon left small>payments</v-icon>
      Antecipar por valor
    </v-btn>
    <div v-if="pending" class="caption orange--text text-xs-center">
      Solicitação em Análise
    </div>

    <v-dialog v-model="dialog" persistent max-width="460px">
      <v-card class="mbv-modal">
        <div class="mbv-head">
          <div class="mbv-head__icon"><v-icon color="white">payments</v-icon></div>
          <span class="mbv-head__title">Antecipar por valor</span>
        </div>
        <v-card-text>
          <p class="body-1 mb-3">
            Informe quanto deseja antecipar. Sua solicitação entra na fila do
            Representante para análise e aprovação. Ao aprovar, antecipamos seus
            recebíveis agendados até cobrir esse valor.
          </p>

          <v-text-field
            label="Valor a antecipar"
            prepend-inner-icon="attach_money"
            v-model.lazy="amount"
            v-money="money"
            ref="amountField"
          ></v-text-field>

          <div class="caption grey--text">
            Taxa de antecipação manual:
            {{ tax && tax.manual_tax ? tax.manual_tax : "N/A" }} % a.m
          </div>
          <div v-if="balance != null" class="caption grey--text">
            Saldo em recebíveis disponível: {{ $n(balance, "currency") }}
          </div>
        </v-card-text>
        <v-card-actions class="mbv-actions">
          <v-spacer></v-spacer>
          <v-btn flat round @click="close" :disabled="sending">Cancelar</v-btn>
          <v-btn
            color="primary"
            round
            depressed
            :loading="sending"
            :disabled="sending || !amountValue"
            @click="submit"
          >
            Enviar solicitação
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="success ? 'success' : 'error'" :timeout="5000">
      <template v-if="success">
        <v-icon left dark>check_circle</v-icon>
        Solicitação enviada — em análise.
      </template>
      <template v-else>
        <v-icon left dark>error</v-icon>
        {{ errorMessage }}
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { VMoney } from "v-money";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ManualByValueAntecipation",
  directives: { money: VMoney },
  created() {
    this.loadAnticipationRequestStatus();
  },
  data() {
    return {
      dialog: false,
      sending: false,
      snackbar: false,
      success: false,
      errorMessage: "Não foi possível enviar a solicitação. Tente novamente.",
      amount: "",
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      pending: "user/anticipationRequestPending",
      tax: "user/anticipationTax",
      balance: "user/balance",
    }),
    amountValue() {
      return Number(String(this.amount).replace(/[^\d]+/g, "")) / 100;
    },
  },
  methods: {
    ...mapActions({
      requestAnticipation: "user/requestAnticipation",
      loadAnticipationRequestStatus: "user/loadAnticipationRequestStatus",
    }),
    close() {
      this.dialog = false;
      this.amount = "";
    },
    submit() {
      if (!this.amountValue) return;
      this.sending = true;
      this.requestAnticipation({ kind: "manual", amount: this.amountValue })
        .then((ok) => {
          this.sending = false;
          this.success = !!ok;
          this.snackbar = true;
          if (ok) this.close();
        })
        .catch(() => {
          this.sending = false;
          this.success = false;
          this.snackbar = true;
        });
    },
  },
};
</script>

<style scoped>
.mbv-modal {
  border-radius: 20px !important;
  overflow: hidden;
}

.mbv-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 22px;
  border-bottom: 1px solid #eef1f5;
}

.mbv-head__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2ec87a, #15a35a);
  box-shadow: 0 6px 14px rgba(21, 163, 90, 0.35);
}

.mbv-head__title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2933;
}

.mbv-actions {
  padding: 8px 18px 18px !important;
}

.mbv-trigger {
  border-radius: 999px !important;
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0.2px;
  box-shadow: 0 6px 16px rgba(47, 111, 224, 0.28) !important;
}

.mbv-btn-primary {
  text-transform: none;
}
</style>
